import lazyLoad from './../utils/lazy'
//import Headroom from "headroom.js"

const cHeaderInit = () => {
  var header = document.querySelector("header")
  // var headroom  = new Headroom(header, {
  //   classes: {
  //     top: "top",
  //     notTop: "not-top"
  //   },
  //   offset: 50
  // })
  // headroom.init()

  let scrollpos = window.scrollY
  const header_height = header.offsetHeight

  window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;

    if (scrollpos >= header_height) {
      header.classList.add("not-top")
    } else { 
      header.classList.remove("not-top")
    }
  })

  const navItems = document.querySelectorAll('.dropdown')

  navItems.forEach(navItem => {
    navItem.addEventListener('mouseenter', function (e) {
        lazyLoad()
    })
  })
}

export default cHeaderInit
